export default __webpack_public_path__ + "static/media/NotoSerif.0677715a.eot";